import { Injectable } from '@angular/core';
import io from 'socket.io-client';
import { Observable, Observer, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { StoreService } from 'src/app/services/store/store.service';

@Injectable({
  providedIn: 'root',
})
export class WsService {
  socket: SocketIOClient.Socket;
  socket_url = environment.socket_url;
  currentUser: any;

  constructor(private storeService: StoreService) {
    const token = this.storeService.getAccessToken();

    this.socket = io(this.socket_url, {
      autoConnect: false,
      auth: { token },
      query: {
        token: token,
      },
    });

    this.socket.on('connect', () => {
      console.info('WebSocket connected', { socketId: this.socket.id });
    });

    this.socket.on('connect_error', (error: Error) => {
      console.error('WebSocket connection failed', { message: error.message });
    });

    this.socket.on('disconnect', (reason: string) => {
      console.warn('WebSocket disconnected', { reason });
    });

    if (token) this.socket.connect();
  }

  listen(eventname: string): Observable<any> {
    return new Observable((observer) => {
      this.socket?.on(eventname, (data) => {
        observer.next(data);
      });
    });
  }

  emit(eventname: string, data: any): void {
    if (eventname === 'newchat') {
      console.info('WebSocket message send requested', {
        connected: this.socket.connected,
        socketId: this.socket.id,
        requestId: data?.chatUUID,
        conversationId: data?.roomId,
        messageLength: data?.chatInfo?.chat?.length || 0,
      });
    }
    this.socket.emit(eventname, data);
  }

  emitWhenConnected(eventname: string, data: any): void {
    if (this.socket.connected) {
      this.socket.emit(eventname, data);
      return;
    }

    this.socket.once('connect', () => this.socket.emit(eventname, data));
  }

  setToken(token: string | null | undefined): void {
    this.socket.io.opts.query = token ? { token } : {};

    if (!token) {
      this.socket.disconnect();
      return;
    }

    // Reconnect so the server authenticates the socket with the new token.
    this.socket.disconnect().connect();
  }
}
